import { Controller } from "@hotwired/stimulus"
import { apiJson } from "../lib/api_errore"

// Leads.js: all'apertura la pagina segna le richieste come lette. È una POST con X-CSRF-Token (mai la GET della pagina,
// K23); a buon fine il contatore della barra laterale sparisce. Errori ignorati, come .catch(() => {}) dell'originale.
export default class extends Controller {
  static values = { url: String }

  async connect() {
    try {
      await apiJson(this.urlValue, { method: "POST" })
      document.querySelector("[data-testid='unread-leads-badge']")?.remove()
    } catch { /* come l'originale */ }
  }
}
